import React from 'react'
  
const PageNotFound = () => {
  return (
    <>
      {/* <img className='pagenotfound' src={PNF} alt="Error 404 - Page Not Found" /> */}
    </>
  )
}

export default PageNotFound